import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {Button, Input, Spacer, Toggle, Text, Password} from "@dspworkplace/ui";

export default function UzioSettingsV2({ initialValues = false, onSubmit }) {
    const { register, handleSubmit, reset, errors } = useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const values = initialValues || {};
        const credentials = values.credentials || {};
        reset({
            ...values,
            apiKey: credentials.api_key || "",
            companyId: credentials.company_id || "",
        });
    }, [initialValues, reset]);

    const handleSave = async (data) => {
        data.credentials = {};
        data.credentials.api_key = data.apiKey;
        data.credentials.company_id = data.companyId ?? '';

        delete data.apiKey;

        setLoading(true);
        onSubmit(data);
    };

    return (
        <form onSubmit={handleSubmit(handleSave)}>
            <input type="hidden" name="id" ref={register} autoComplete="off" />
            <input type="hidden" value="UZIO" name="integration_type" ref={register} autoComplete="off" />

            <Input
                ref={register({ required: true })}
                name="name"
                label="Account name"
                Required={true}
                invalid={errors && errors.name}
                error={errors && errors.name && "Required field"}
                autoComplete="off"
                help="A name to identify this Uzio account inside DSP."
            />
            <Spacer bottom={3} />
            <Toggle ref={register} name="enabled" singleText="Enable this account" />
            <Spacer bottom={3} />
            <Toggle
                ref={register}
                name="syncTimeOff"
                // help="If this is enabled, the system will automatically fetch ADP punch data."
                singleText="Enable TimeOff Sync"
            />
            <Spacer bottom={3} />
            <Password
                ref={register({ required: true })}
                name="apiKey"
                label="Uzio API Key"
                Required={true}
                valid={!errors || !errors.apiKey}
                invalid={errors && errors.apiKey}
                error={errors && errors.apiKey && "Required field"}
                autoComplete="off"
            />
            <Spacer bottom={5} />

            <Button type="primary" disabled={loading}>
                {!loading ? "Save" : "Saving..."}
            </Button>
        </form>
    );
}
